"use client";
import { jsx, Fragment } from "react/jsx-runtime";
import "./medium.css.js";
import "./regular.css.js";
const DahlesFont = () => jsx(Fragment, {});
export {
  DahlesFont
};
